<template>
  <div class="destination-list-search-bar">
    <input
      class="search-input icon-search"
      :placeholder="searchPlaceholder"
      value=""
      @input="triggerFilter"
    >
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      searchPlaceholder: {
        type: String,
        default: 'Find your preferred Local MO'
      },
    },
    computed: {
      ...mapGetters('i18n', ['tc'])
    },
    methods: {
      triggerFilter(val) {
        this.$emit('filter-items', val.currentTarget.value, 'input')
      }
    }
  }
</script>
